<script lang="ts">
  import { router } from '@inertiajs/svelte';

  interface Survey {
    id: string;
    slug: string;
    title: string;
    description: string | null;
    published_at: string | null;
    closed_at: string | null;
    responses_count: number;
    public_url: string;
    published: boolean;
  }

  let { surveys }: { surveys: Survey[] } = $props();

  function close(slug: string) {
    if (!confirm('정말 종료하시겠습니까?')) return;
    router.post(`/admin/community/surveys/${slug}/close`);
  }
</script>

<div class="p-6 space-y-6">
    <header class="flex items-center justify-between">
      <h1 class="text-2xl font-bold">설문 관리</h1>
      <a href="/admin/community/surveys/new"
         class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        + 새 설문
      </a>
    </header>

    <div class="bg-white border rounded overflow-hidden">
      <table class="w-full">
        <thead class="bg-gray-50 text-left text-sm">
          <tr>
            <th class="p-3">제목</th>
            <th class="p-3">Slug</th>
            <th class="p-3">응답 수</th>
            <th class="p-3">상태</th>
            <th class="p-3"></th>
          </tr>
        </thead>
        <tbody>
          {#each surveys as s}
            <tr class="border-t hover:bg-gray-50">
              <td class="p-3 font-medium">{s.title}</td>
              <td class="p-3 font-mono text-xs text-gray-600">{s.slug}</td>
              <td class="p-3">{s.responses_count}</td>
              <td class="p-3">
                {#if s.published}
                  <span class="px-2 py-0.5 rounded bg-green-100 text-green-800 text-xs">공개중</span>
                {:else if s.closed_at}
                  <span class="px-2 py-0.5 rounded bg-gray-100 text-gray-600 text-xs">종료</span>
                {:else}
                  <span class="px-2 py-0.5 rounded bg-yellow-100 text-yellow-800 text-xs">초안</span>
                {/if}
              </td>
              <td class="p-3 space-x-2 text-sm">
                <a href={`/admin/community/surveys/${s.slug}/edit`} class="text-blue-600 hover:underline">편집</a>
                <a href={`/admin/community/surveys/${s.slug}/responses`} class="text-gray-700 hover:underline">응답</a>
                <a href={s.public_url} target="_blank" rel="noopener" class="text-gray-500 hover:underline">↗ 공개링크</a>
                {#if !s.closed_at}
                  <button onclick={() => close(s.slug)} class="text-red-600 hover:underline">종료</button>
                {/if}
              </td>
            </tr>
          {/each}
          {#if surveys.length === 0}
            <tr><td colspan="5" class="p-6 text-center text-gray-500">설문 없음</td></tr>
          {/if}
        </tbody>
      </table>
    </div>
  </div>
